/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Role_DosenInputs */

const en_cp_role_dosen = /** @type {(inputs: Cp_Role_DosenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecturer / coordinator`)
};

const id_cp_role_dosen = /** @type {(inputs: Cp_Role_DosenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosen / koordinator`)
};

/**
* | output |
* | --- |
* | "Lecturer / coordinator" |
*
* @param {Cp_Role_DosenInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_role_dosen = /** @type {((inputs?: Cp_Role_DosenInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Role_DosenInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_role_dosen(inputs)
	return en_cp_role_dosen(inputs)
});